<div *ngIf="emptyReports || noReports" class="report-empty-state-component empty-reports">
  <h3 class="report-empty-header" data-test="header-text">{{ headerText }}</h3>
  <p class="report-empty-message" data-test="message-text">{{ messageText }}</p>
</div>
